import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress, {
	CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

interface Props {
	value: number;
	type: string;
}

const CircularProgressWithLabel = (props: CircularProgressProps & Props) => {
	const theme = useTheme();

	// Map % to red→orange→green, only green at 100%
	const bandColor = (() => {
		const { error, warning, success } = theme.palette;
		const pct = props.value;
		if (pct >= 100) return success.main; // green only when 100%
		if (pct >= 75) return warning.main; // lighter orange
		if (pct >= 50) return warning.dark; // darker orange
		if (pct >= 25) return error.main; // lighter red
		return error.dark; // darkest red
	})();

	return (
		<Box sx={{ position: "relative", display: "inline-flex" }}>
			<CircularProgress
				variant="determinate"
				{...props}
				sx={{
					color: bandColor,
					// modern slightly thicker stroke
					"& .MuiCircularProgress-circle": { strokeLinecap: "round" },
				}}
			/>
			<Box
				sx={{
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
					position: "absolute",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Typography
					variant="caption"
					component="div"
					color="text.primary"
					sx={{ fontWeight: 600 }}
				>
					{`${Math.round(props.value)}${props.type}`}
				</Typography>
			</Box>
		</Box>
	);
};

export default CircularProgressWithLabel;
